export type RequestIdentity = { current: number };

export const nextRequest = (identity: RequestIdentity): number => ++identity.current;
export const isLatestRequest = (identity: RequestIdentity, request: number): boolean =>
  identity.current === request;
export const cancelRequests = (identity: RequestIdentity): void => {
  identity.current += 1;
};
